import type { en } from "./en.ts";

export const fr: typeof en = {
    Errors: {
        loadFailed: "Impossible de charger les compétences.",
        reassurance: "Rien n'est perdu. Réessayez dans un instant.",
        retry: "Réessayer",
        refreshBanner: "Impossible d'actualiser la liste. Les résultats précédents sont affichés."
    },
    SkillGrid: {
        searchPlaceholder: "Rechercher des compétences",
        searchAriaLabel: "Rechercher des compétences",
        featureFilter: "Fonctionnalité",
        featureFilterSelected_one: "{{count}} fonctionnalité",
        featureFilterSelected_other: "{{count}} fonctionnalités",
        featureFilterAriaLabel: "Filtrer par fonctionnalité",
        clearFeatureFilter: "Effacer le filtre",
        clearAllFilters: "Effacer tous les filtres",
        resultCount_one: "{{count}} compétence",
        resultCount_other: "{{count}} compétences",
        resultCountFiltered_one: "{{count}} compétence sur {{total}}",
        resultCountFiltered_other: "{{count}} compétences sur {{total}}",
        noResults: "Aucune compétence ne correspond à vos filtres.",
        noResultsHint: "Essayez une autre recherche ou retirez un filtre.",
        noSkillsYet: "Aucune compétence pour le moment.",
        comingSoon: "Bientôt disponible"
    },
    SkillNotFound: {
        heading: "Compétence introuvable",
        body: "Cette compétence n'existe pas ou n'est pas disponible.",
        backToSkills: "Retour aux compétences"
    },
    SkillTemplateByline: {
        workleap: "Workleap",
        you: "Vous",
        organizationFallback: "Votre organisation"
    },
    SkillTemplateViewer: {
        viewOnly: "Lecture seule",
        editCopy: "Dupliquer",
        contentLabel: "Instructions de l'agent"
    },
    SkillTryItNowButton: {
        label: "Essayer"
    }
};
